(function () {
  'use strict';

  /* ===== EDIT THESE LISTS: [name, swatch color, words to look for] ===== */
  var COLORS = [
    ['Black', '#111111', ['black']],
    ['White', '#ffffff', ['white']],
    ['Ivory', '#f4eedc', ['ivory', 'cream', 'off white', 'off-white', 'offwhite']],
    ['Beige', '#d8c3a5', ['beige', 'nude', 'sand', 'fawn', 'tan', 'champagne']],
    ['Grey', '#9a9a9a', ['grey', 'gray', 'charcoal', 'silver', 'slate', 'ash']],
    ['Blue', '#2f5fa8', ['blue', 'navy', 'cobalt']],
    ['Teal', '#1f8a8a', ['teal', 'turquoise', 'aqua', 'peacock']],
    ['Green', '#3a7d44', ['green', 'olive', 'emerald', 'sage', 'mint', 'mehndi', 'bottle']],
    ['Yellow', '#e8c33a', ['yellow', 'mustard', 'lemon']],
    ['Gold', '#c9a24a', ['gold', 'golden']],
    ['Orange', '#e2792b', ['orange', 'rust', 'tangerine']],
    ['Peach', '#f2b49a', ['peach', 'coral', 'salmon']],
    ['Red', '#c8202f', ['red', 'scarlet', 'crimson']],
    ['Maroon', '#6f1d2b', ['maroon', 'burgundy', 'wine', 'oxblood']],
    ['Pink', '#e88aa7', ['pink', 'blush', 'rose', 'fuchsia', 'magenta']],
    ['Purple', '#7d4a9c', ['purple', 'lilac', 'lavender', 'mauve', 'violet', 'plum']],
    ['Brown', '#7a5238', ['brown', 'chocolate', 'coffee', 'camel', 'mocha']]
  ];
  var CUTLINES = [
    ['A-Line', ['a-line', 'a line', 'aline']],
    ['Straight', ['straight']],
    ['Flared', ['flared', 'flare']],
    ['Angrakha', ['angrakha']],
    ['Peplum', ['peplum']],
    ['Anarkali', ['anarkali']],
    ['Kaftan', ['kaftan', 'caftan']],
    ['Front Open', ['front open', 'front-open']],
    ['Jacket', ['jacket']],
    ['Sharara / Gharara', ['sharara', 'gharara', 'garara']],
    ['Farshi', ['farshi']],
    ['Kali', ['kali', 'kalidar']],
    ['Tunic', ['tunic']],
    ['Cape', ['cape']],
    ['Short Shirt', ['short shirt', 'short kurta']],
    ['Long Shirt', ['long shirt', 'maxi']]
  ];
  /* ===================================================================== */

  function rx(words) {
    return words.map(function (w) {
      return new RegExp('(^|[^a-z])' + w.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&') + '([^a-z]|$)');
    });
  }
  var COLORS_C = COLORS.map(function (c) { return { name: c[0], hex: c[1], res: rx(c[2]) }; });
  var CUTS_C = CUTLINES.map(function (c) { return { name: c[0], res: rx(c[1]) }; });

  function matchNames(list, text) {
    var out = [];
    list.forEach(function (item) {
      for (var i = 0; i < item.res.length; i++) {
        if (item.res[i].test(text)) { out.push(item.name); break; }
      }
    });
    return out;
  }

  var state = { min: null, max: null, sale: false, colors: {}, cuts: {} };
  var drawer = null, gridRef = null, loadingAll = null;
  var isOpen = false, hasEntry = false, priceTimer = null;

  var X_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"><path d="M5 5l14 14M19 5L5 19"/></svg>';
  var CARET = '<svg viewBox="0 0 10 10" fill="none" stroke="currentColor" stroke-width="1.2"><path d="M1 3l4 4 4-4"/></svg>';

  function info(li) {
    if (li.__tsb) return li.__tsb;
    var title = li.getAttribute('data-tsb-title') || '';
    var opts = li.getAttribute('data-tsb-opts') || '';
    var desc = li.getAttribute('data-tsb-text') || '';
    var d = {
      price: (parseFloat(li.getAttribute('data-tsb-price')) || 0) / 100,
      sale: li.getAttribute('data-tsb-sale') === '1',
      colors: matchNames(COLORS_C, opts + ' ' + title),
      cuts: []
    };
    if (!d.colors.length) d.colors = matchNames(COLORS_C, desc.slice(0, 260));
    d.cuts = matchNames(CUTS_C, title + ' ' + desc);
    li.__tsb = d;
    return d;
  }

  function anyOn(obj) { return Object.keys(obj).some(function (k) { return obj[k]; }); }
  function anyActive() { return state.min !== null || state.max !== null || state.sale || anyOn(state.colors) || anyOn(state.cuts); }

  function match(li) {
    var d = info(li);
    if (state.min !== null && d.price < state.min) return false;
    if (state.max !== null && d.price > state.max) return false;
    if (state.sale && !d.sale) return false;
    if (anyOn(state.colors) && !d.colors.some(function (c) { return state.colors[c]; })) return false;
    if (anyOn(state.cuts) && !d.cuts.some(function (c) { return state.cuts[c]; })) return false;
    return true;
  }

  function apply() {
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    var any = anyActive(), shown = 0;
    Array.prototype.forEach.call(grid.children, function (li) {
      var ok = !any || match(li);
      li.classList.toggle('tsb-hide', !ok);
      if (ok) shown++;
    });
    var none = document.getElementById('TsbNone');
    if (any && !shown) {
      if (!none) {
        none = document.createElement('p');
        none.id = 'TsbNone';
        none.className = 'tsb-none';
        none.textContent = 'No products match these filters.';
        grid.parentNode.appendChild(none);
      }
    } else if (none) {
      none.remove();
    }
    var b = document.querySelector('.tsb-fbtn');
    if (b) b.classList.toggle('is-active', any);
  }

  /* ----- load every page of the collection so filters see all products ----- */
  function dedupe() {
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    var seen = {};
    Array.prototype.slice.call(grid.children).forEach(function (li) {
      var id = li.getAttribute('data-tsb-id');
      if (!id) return;
      if (seen[id]) li.remove(); else seen[id] = 1;
    });
  }

  function setLoading(on) {
    if (!drawer) return;
    var p = drawer.querySelector('.tsb-fd__loading');
    if (p) p.hidden = !on;
  }

  function ensureAll() {
    if (loadingAll) return loadingAll;
    var grid = document.getElementById('product-grid');
    var s = document.getElementById('TsbInfinite');
    var next = s ? s.getAttribute('data-next') : null;
    if (s) s.remove();
    if (!next) { loadingAll = Promise.resolve(); return loadingAll; }
    setLoading(true);
    loadingAll = new Promise(function (resolve) {
      function restore(url) {
        var d = document.createElement('div');
        d.id = 'TsbInfinite';
        d.setAttribute('data-next', url);
        var g = document.getElementById('product-grid');
        if (g && g.parentNode) g.parentNode.appendChild(d);
        loadingAll = null;
      }
      function step(url) {
        if (!url) { resolve(); return; }
        fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var ng = doc.getElementById('product-grid');
            var g = document.getElementById('product-grid');
            if (ng && g && g === grid) {
              Array.prototype.forEach.call(ng.children, function (li) {
                var id = li.getAttribute('data-tsb-id');
                if (id && g.querySelector('[data-tsb-id="' + id + '"]')) return;
                li.classList.remove('scroll-trigger', 'animate--slide-in');
                li.removeAttribute('data-cascade');
                li.removeAttribute('style');
                li.querySelectorAll('.scroll-trigger').forEach(function (n) {
                  n.classList.remove('scroll-trigger', 'animate--slide-in');
                  n.removeAttribute('data-cascade');
                });
                g.appendChild(document.importNode(li, true));
              });
            }
            var n = doc.getElementById('TsbInfinite');
            step(n ? n.getAttribute('data-next') : null);
          })
          .catch(function () { restore(url); resolve(); });
      }
      step(next);
    }).then(function () {
      dedupe();
      setLoading(false);
      setTimeout(function () { dedupe(); if (anyActive()) apply(); }, 1500);
    });
    return loadingAll;
  }

  /* ----- drawer ----- */
  function sec(key, label, inner) {
    return '<section class="tsb-fd__sec tsb-fd__sec--' + key + '">' +
      '<button type="button" class="tsb-fd__row" aria-expanded="false"><span>' + label + '</span><i class="tsb-fd__plus"></i></button>' +
      '<div class="tsb-fd__content" hidden>' + inner + '</div></section>';
  }

  function build() {
    if (drawer) return;
    var sortSel = document.getElementById('SortBy');
    var sortHtml = '';
    if (sortSel) {
      sortHtml = sec('sort', 'Sort by', '<select class="tsb-fd__sort" id="TsbSort">' +
        Array.prototype.map.call(sortSel.options, function (o) {
          return '<option value="' + o.value.replace(/"/g, '&quot;') + '"' + (o.selected ? ' selected' : '') + '>' + o.textContent.trim() + '</option>';
        }).join('') + '</select>');
    }
    drawer = document.createElement('div');
    drawer.className = 'tsb-fd';
    drawer.hidden = true;
    drawer.innerHTML =
      '<div class="tsb-fd__bg" data-fd-close></div>' +
      '<aside class="tsb-fd__panel" role="dialog" aria-modal="true" aria-label="Filters">' +
      '<div class="tsb-fd__head"><h2 class="tsb-fd__title">Filters</h2><button type="button" class="tsb-fd__x" data-fd-close aria-label="Close">' + X_SVG + '</button></div>' +
      '<div class="tsb-fd__body"><p class="tsb-fd__loading" hidden>Loading all products...</p>' +
      sortHtml +
      sec('price', 'Price', '<div class="tsb-fd__price"><label>From (USD)<input type="number" min="0" step="1" id="TsbMin" inputmode="numeric"></label><label>To (USD)<input type="number" min="0" step="1" id="TsbMax" inputmode="numeric"></label></div>') +
      sec('color', 'Color', '<div class="tsb-fd__list" id="TsbColors"></div>') +
      sec('sale', 'Sale', '<div class="tsb-fd__list"><label class="tsb-fd__opt"><input type="checkbox" name="sale"><span>On sale</span></label></div>') +
      sec('cutline', 'Cutline', '<div class="tsb-fd__list" id="TsbCuts"></div>') +
      '</div>' +
      '<div class="tsb-fd__foot"><button type="button" data-fd-clear>Clear all</button><button type="button" class="is-solid" data-fd-close>Apply filters</button></div>' +
      '</aside>';
    document.body.appendChild(drawer);

    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-fd-close]')) { requestClose(); return; }
      if (e.target.closest('[data-fd-clear]')) { clearAll(); return; }
      var row = e.target.closest('.tsb-fd__row');
      if (row) {
        var open = row.getAttribute('aria-expanded') === 'true';
        row.setAttribute('aria-expanded', open ? 'false' : 'true');
        row.nextElementSibling.hidden = open;
      }
    });
    drawer.addEventListener('change', function (e) {
      var t = e.target;
      if (t.name === 'color') state.colors[t.value] = t.checked;
      else if (t.name === 'cut') state.cuts[t.value] = t.checked;
      else if (t.name === 'sale') state.sale = t.checked;
      else if (t.id === 'TsbSort') {
        var s = document.getElementById('SortBy');
        if (s) {
          s.value = t.value;
          s.dispatchEvent(new Event('input', { bubbles: true }));
          s.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      } else return;
      changed();
    });
    drawer.addEventListener('input', function (e) {
      var t = e.target;
      if (t.id !== 'TsbMin' && t.id !== 'TsbMax') return;
      clearTimeout(priceTimer);
      priceTimer = setTimeout(function () {
        var a = parseFloat(drawer.querySelector('#TsbMin').value);
        var b = parseFloat(drawer.querySelector('#TsbMax').value);
        state.min = isNaN(a) ? null : a;
        state.max = isNaN(b) ? null : b;
        changed();
      }, 300);
    });
  }

  function populate() {
    if (!drawer) return;
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    var colors = {}, cuts = {}, min = Infinity, max = 0;
    Array.prototype.forEach.call(grid.children, function (li) {
      var d = info(li);
      d.colors.forEach(function (c) { colors[c] = 1; });
      d.cuts.forEach(function (c) { cuts[c] = 1; });
      if (d.price) { min = Math.min(min, d.price); max = Math.max(max, d.price); }
    });
    var cl = drawer.querySelector('#TsbColors');
    var html = COLORS_C.filter(function (c) { return colors[c.name]; }).map(function (c) {
      return '<label class="tsb-fd__opt"><input type="checkbox" name="color" value="' + c.name + '"' + (state.colors[c.name] ? ' checked' : '') + '>' +
        '<span class="tsb-fd__dot" style="background:' + c.hex + '"></span><span>' + c.name + '</span></label>';
    }).join('');
    cl.innerHTML = html || '<p class="tsb-fd__empty">No colors detected.</p>';
    var ul = drawer.querySelector('#TsbCuts');
    html = CUTS_C.filter(function (c) { return cuts[c.name]; }).map(function (c) {
      return '<label class="tsb-fd__opt"><input type="checkbox" name="cut" value="' + c.name + '"' + (state.cuts[c.name] ? ' checked' : '') + '><span>' + c.name + '</span></label>';
    }).join('');
    ul.innerHTML = html || '<p class="tsb-fd__empty">No cutlines detected in the descriptions.</p>';
    if (isFinite(min)) {
      drawer.querySelector('#TsbMin').placeholder = Math.floor(min);
      drawer.querySelector('#TsbMax').placeholder = Math.ceil(max);
    }
  }

  function changed() {
    apply();
    ensureAll().then(function () { populate(); apply(); });
  }

  function clearAll() {
    state = { min: null, max: null, sale: false, colors: {}, cuts: {} };
    if (drawer) {
      drawer.querySelectorAll('input[type="checkbox"]').forEach(function (i) { i.checked = false; });
      drawer.querySelector('#TsbMin').value = '';
      drawer.querySelector('#TsbMax').value = '';
    }
    apply();
  }

  function openDrawer() {
    build();
    drawer.hidden = false;
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    isOpen = true;
    document.documentElement.style.overflow = 'hidden';
    history.pushState({ tsbFd: 1 }, '');
    hasEntry = true;
    populate();
    ensureAll().then(function () { populate(); apply(); });
  }
  function closeUI() {
    if (!isOpen) return;
    isOpen = false;
    drawer.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { if (!isOpen) drawer.hidden = true; }, 300);
  }
  function requestClose() {
    if (hasEntry) { hasEntry = false; history.back(); } else closeUI();
  }
  window.addEventListener('popstate', function () {
    if (isOpen) { hasEntry = false; closeUI(); }
  });
  document.addEventListener('keydown', function (e) {
    if (isOpen && e.key === 'Escape') requestClose();
  });

  /* ----- the Filters button ----- */
  function ensureButton() {
    var bar = document.querySelector('.facets-container-drawer');
    if (!bar || bar.querySelector('.tsb-fbtn')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'tsb-fbtn';
    b.innerHTML = '<span>Filters</span>' + CARET;
    b.addEventListener('click', openDrawer);
    bar.insertBefore(b, bar.firstChild);
    b.classList.toggle('is-active', anyActive());
  }

  var queued = false;
  function watch() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      ensureButton();
      var g = document.getElementById('product-grid');
      if (g && g !== gridRef) {
        gridRef = g;
        loadingAll = null;
        if (anyActive()) { apply(); ensureAll().then(function () { populate(); apply(); }); }
      }
    });
  }
  new MutationObserver(watch).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', watch);
  window.addEventListener('load', watch);
})();